<template>
  <div class="footer">
    <div
      v-if="showWechatQr"
      class="modal-backdrop"
      @click="showWechatQr = false"
    >
      <div class="modal">
        <div>
          <!-- <qrcode
            :value="'http://weixin.qq.com/r/Ey1udrjEh_X4rfwV93gB'"
            :options="{width: 500, height: 500}"
          /> -->
          <img src="@/assets/index/wechat_gzh.png">
        </div>
      </div>
    </div>
    <div class="sns">
      <a href="https://weibo.com/u/7549933603">
        <img src="@/assets/icons/weibo@2x.png">
        <p>微博</p>
      </a>
      <a href="https://space.bilibili.com/405469062?spm_id_from=333.788.b_765f7570696e666f.2">
        <img src="@/assets/icons/bilibili@2x.png">
        <p>哔哩哔哩</p>
      </a>
      <a
        class="sns-wechat-mobile"
        href="https://weixin.qq.com/r/Ey1udrjEh_X4rfwV93gB"
      >
        <img src="@/assets/icons/wechat@2x.png">
        <p>微信</p>
      </a>
      <a
        class="sns-wechat-desktop"
        style="cursor: pointer;"
        @click="showWechatQr = true"
      >
        <img src="@/assets/icons/wechat@2x.png">
        <p>微信</p>
      </a>
    </div>
    <p
      class="mt-5 text-xs text-center contact"
      @click="openICP"
    >
      粤ICP备2023070669号<br>
      广州盈声科技有限公司版权所有
      <!-- 联繫电话：13719330829<br>  -->
    </p>
    <div class="w-full copyright">
      <hr>
      <div class="flex flex-row py-3">
        <span>© 2020 Positive Grid. All Rights Reserved.</span>
        <!-- 阿里云备案要去除 -->
        <!-- <span>广州盈声科技有限公司 <a
          href="http://beian.miit.gov.cn/"
          target="_blank"
        >粤ICP备19002517号-1</a></span> -->
        <a
          class="pl-5 ml-5 privacy"
          href="https://www.positivegrid.com/privacy/"
        >隐私政策</a>
        <div class="flex align-center">
          <img
            src="@/assets/icons/pg-logo-footer@2x.png"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  components: {
    // qrcode: VueQrcode
  },
  data () {
    return {
      showWechatQr: false
    }
  },
  methods: {
    openICP () {
      window.open('https://beian.miit.gov.cn/')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 260px;
  background-color: #222222;
  position: relative;
}

.footer .sns {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 30px;
}

.footer .sns a {
  text-decoration: none;
  color: #c4c4c4;
  margin: 0 20px;
}

.footer .sns img {
  height: 64px;
}

.copyright {
  padding: 0 52px;
  position: absolute;
  bottom: 0;

  @media screen and (max-width: 768px) {
    padding: 0 20px;
    margin-top: 1rem;
  }

  hr {
    border-color: #d8d8d8;
  }

  .privacy {
    border-left: 1px solid #afafaf;

    @media screen and (max-width: 768px) {
      border: none;
      margin: 0;
      padding: 0;
    }
  }

  div {
    margin-left: auto;

    @media screen and (max-width: 768px) {
      flex-direction: column;
    }

    img {
      height: 12px;
      width: 86px;
    }
  }
}

.copyright div > * {
  height: 16px;
  font-size: 12px;
  color: #afafaf;
  line-height: 16px;
}

.copyright .vl {
  border-left: 1px solid #afafaf;
  height: 20px;
  margin: 0 20px;
  width: 1px;
}

.modal-backdrop {
  z-index: 2;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #282828;
  box-shadow: 0 2px 23px 0 rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 40vw;
  height: 40vw;
  justify-content: center;
  align-items: center;
}

.modal canvas {
  height: 30vw !important;
  width: 30vw !important;
}

.sns-wechat-mobile {
  display: none;
}
@media screen and (max-width: 768px) {

  .copyright img {
    display: none;
  }
  .sns-wechat-mobile {
    display: block;
  }
  .sns-wechat-desktop {
    display: none;
  }
}

a {
  text-decoration: none;
}
a:link, a:visited {
  color: #afafaf;
  font-weight: 300;
}

.contact {
  color: #868686;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/footer-common.vue